import { Link } from "react-router-dom";

const CATEGORY_LINKS = [
  { label: "趣味视频", to: "/category/video" },
  { label: "搞笑段子", to: "/category/joke" },
  { label: "轻松访谈", to: "/category/interview" },
];

const SITE_LINKS = [
  { label: "首页", to: "/" },
  { label: "搜索内容", to: "/search" },
  { label: "关于我们", to: "/about" },
  { label: "隐私政策", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 mt-16">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2 font-heading font-bold text-lg">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-emotion-happy-line text-xl" />
            </span>
            羞羞网站
          </div>
          <p className="text-sm text-background-50/70 leading-relaxed">
            综合娱乐内容聚合平台，用趣味视频、搞笑段子和轻松访谈，为你的每一天加一点快乐。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading font-semibold text-sm text-background-50">
            <Link to="/" className="hover:text-primary-300">内容分类</Link>
          </h4>
          {CATEGORY_LINKS.map((link) => (
            <Link key={link.label} to={link.to} className="text-sm text-background-50/70 hover:text-primary-300 w-fit">
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading font-semibold text-sm text-background-50">
            <Link to="/about" className="hover:text-primary-300">快速导航</Link>
          </h4>
          {SITE_LINKS.map((link) => (
            <Link key={link.label} to={link.to} className="text-sm text-background-50/70 hover:text-primary-300 w-fit">
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading font-semibold text-sm text-background-50">联系我们</h4>
          <p className="text-sm text-background-50/70">合作与反馈邮箱</p>
          <a href="mailto:hello@xiuxiu.fun" className="text-sm text-primary-300 hover:text-primary-200 w-fit">
            hello@xiuxiu.fun
          </a>
          <div className="flex items-center gap-3 mt-1">
            <a href="https://wsswx2ray.asia" target="_blank" rel="noopener" aria-label="微博" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors">
              <i className="ri-weibo-fill" />
            </a>
            <a href="https://www.douyin.com" target="_blank" rel="noopener" aria-label="抖音" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors">
              <i className="ri-music-2-line" />
            </a>
            <a href="https://www.bilibili.com" target="_blank" rel="noopener" aria-label="哔哩哔哩" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors">
              <i className="ri-play-circle-line" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-50/60">
          <p>© {new Date().getFullYear()} 羞羞网站 · 综合娱乐内容聚合平台 · 仅供演示</p>
          <div className="flex items-center gap-5">
            <Link to="/about" className="hover:text-primary-300">隐私政策</Link>
            <Link to="/about" className="hover:text-primary-300">用户协议</Link>
            <Link to="/about" className="hover:text-primary-300">意见反馈</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}